import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

import styles from "../../../styles.module.css";

const DialogConfirm = ({ open, onClose, title, content }) => {
  return (
    <Dialog open={open} onClose={() => onClose(false)} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => onClose(false)}
          color="primary"
          className={styles.redButton}
        >
          Cancel
        </Button>
        <Button
          onClick={() => onClose(true)}
          color="primary"
          autoFocus
          className={styles.primaryButton}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirm;
